  <template>
  <va-card title="Gateways">
    <template slot="actions">
      <va-button @click="addNew"> Add new </va-button>
    </template>

    <div class="row align--center mb-1">
      <div class="flex xs12 sm6">
        <va-input class="ma-0" :value="searchTerm" placeholder="Search" @input="search">
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
    </div>

    <div v-if="loading" class="hiq-spinner-div">
      <img class="hiq-spinner" src="/assets/rpspinnerb.png" />
    </div>
    <va-data-table
      ref="datatable"
      :fields="fields"
      :data="filteredData"
      :selection-id="currentSelId"
      no-pagination
      @row-clicked="rowClicked"
      clickable
      no-data-label="No accounts"
      hoverable
      ext-link-field="__slot:extlink"
      v-if="!loading"
      style="height: 40vh"
    >
    </va-data-table>

    <va-modal v-model="showCreateDialog" :noOutsideDismiss="true" :hideDefaultActions="true" title="Create Gateway">
      <form>
        <div class="row">
          <div class="flex xs12">
            <va-input v-model="dialogSerialVal" label="Serial"></va-input>
          </div>
        </div>
        <div class="row">
          <div class="flex xs12">
            <va-input v-model="dialogNameVal" label="Name"></va-input>
          </div>
        </div>
      </form>

      <template slot="actions">
        <va-button @click="dialogSave">Create</va-button>
        <va-button @click="dialogCancel">Cancel</va-button>
      </template>
      <span v-if="showSaving">Creating...</span>
      <span style="color: red">{{ errorSaving }}</span>
    </va-modal>
  </va-card>
</template>

<script>
import { debounce } from 'lodash'
import hiqapi from '@/hiqapi/hiqapi'

export default {
  data() {
    return {
      loading: true,
      searchTerm: null,
      listData: [], // list of currentListType
      currentSelId: null,

      accountList: [],

      showCreateDialog: false,
      dialogSerialVal: '',
      dialogNameVal: '',
      showSaving: false,
      errorSaving: '',
    }
  },
  computed: {
    fields() {
      return [
        { name: 'serial', sortField: 'serial', title: 'Serial' },
        { name: 'name', sortField: 'name', title: 'Name' },
        { name: 'site_name', sortField: 'site_name', title: 'Site' },
      ]
    },

    filteredData() {
      let data = this.listData

      if (!this.searchTerm || this.searchTerm.length < 1) {
        return data
      }

      return data.filter((item) => {
        var st = this.searchTerm.toLowerCase()
        return item.serial.toString().indexOf(st) === 0 || // only match start of serial
               (item.name && item.name.toLowerCase().indexOf(st) !== -1)
      })
    },
  },

  methods: {
    addNew() {
      if (this.showCreateDialog) {
        return
      }
      console.log('ADD')
      this.dialogSerialVal = ''
      this.dialogNameVal = ''
      this.showSaving = false
      this.errorSaving = ''
      this.showCreateDialog = true
    },

    async dialogSave() {
      console.log('SAVE ', this.dialogNameVal)
      this.errorSaving = ''
      this.showSaving = true

      let data = {
        serial: this.dialogSerialVal,
        name: this.dialogNameVal,
      }

      let resp = await hiqapi.postPutWait('post', '/gateways', data)

      this.showSaving = false

      if (resp.status >= 400) {
        this.errorSaving = resp.data.message
      } else {
        this.showToast('Gateway created', {
          position: 'top-right',
        })

        this.showCreateDialog = false
        this.reload()
      }
    },

    dialogCancel() {
      console.log('CANCEL')
      this.showCreateDialog = false
    },

    rowClicked(item) {
      console.log('**************************************** GatewayList CLICK ON ', item)
      this.$root.$emit('gateway_selected', item, null)
    },

    setData(newval) {
      this.loading = false
      this.listData = newval.items
      // Vuetable uses "item_id" to track which row is selected
      this.listData.forEach((item) => {
        item['item_id'] = item['serial'].toString()
      })
      this.listData.sort((a, b) => {
        return a.serial > b.serial ? 1 : b.serial > a.serial ? -1 : 0
      })
    },

    search: debounce(function(searchTerm) {
      this.searchTerm = searchTerm
    }, 400),

    reload() {
      this.isLoading = true
      hiqapi.getcb('/gateways?include_site=yes', this.setData)
    },
  },

  mounted() {
    this.$root.$on('reload_gateway_list', (arg1, arg2) => {
      this.reload()
    })
    this.reload()
  },
}
</script>

<style lang="scss">
.font-awesome-icon {
  color: #bebebe;
}
.hiq-spinner-div {
  display: flex;
  justify-content: center;
  padding: 30px;
}
.hiq-spinner {
  animation-duration: 1.5s;
  animation-timing-function: cubic-bezier(0.54, 0.18, 0.46, 0.82);
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-fill-mode: none;
  animation-play-state: running;
  animation-name: spinner-rotation;
}
@keyframes spinner-rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
</style>
